/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { HtmlHeadInclude } from '@msdyn365-commerce/core';
import * as React from 'react';
import { IHeiSailthruSignupFormViewProps } from './hei-sailthru-signup-form';

let sailthruInit = false;

export default (props: IHeiSailthruSignupFormViewProps) => {
    const { customerId, template, source, className } = props.config;
    const [email, setEmail] = React.useState('');
    const [isSubmited, setIsSubmited] = React.useState(false);

    React.useEffect(() => {
        if (!sailthruInit && window['Sailthru']) {
            sailthruInit = true;
            const Sailthru = window['Sailthru'];
            Sailthru.init({ customerId: customerId });
        }
    }, [customerId]);

    return (
        <div className={`row hei-sailthru-signup-form ${className}`}>
            <HtmlHeadInclude>
                <script data-load-point='headEnd' src='https://ak.sail-horizon.com/spm/spm.v1.min.js'></script>
            </HtmlHeadInclude>

            {isSubmited ? (
                <div className='hei-sailthru-signup-form-message'>{props.resources.postNewsletterSubscribeMsg}</div>
            ) : (
                <>
                    <div className='hei-sailthru-signup-form-email'>
                        <input
                            className='form-control'
                            type='email'
                            placeholder={props.resources.emailInputPlaceholder}
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />
                    </div>
                    <div className='hei-sailthru-signup-form-btn'>
                        <button
                            className='btn msc-btn'
                            type='button'
                            onClick={() => {
                                const Sailthru = window['Sailthru'];
                                if (!Sailthru || !email) {
                                    return;
                                }

                                const payload = {
                                    id: email,
                                    key: 'email',
                                    template: { name: template },
                                    source: source,
                                    onSuccess: () => {
                                        setIsSubmited(true);
                                    },
                                    onError: () => {
                                        console.warn('Sailthru subscription failed.');
                                    }
                                };

                                Sailthru.integration('userSignUpConfirmedOptIn', payload);
                            }}
                        >
                            {props.resources.submitBtnLabel}
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};
